// shouldShowAlbumSkeleton 等待接口、页面挂载和本批图片请求全部结束
export const shouldShowAlbumSkeleton = (pending, hydrated, imagesSettled) => Boolean(pending) || !hydrated || !imagesSettled
